export const defaultErrorMessage =
  'Oops. We seem to be experiencing some technical difficulty. Sorry for the inconvenience. Please try again later.';

export default defaultErrorMessage;